import {Injectable} from "@angular/core";
import {RouteService} from "./routeService";
import {NotificationService} from "./notificationService";
import {DICTIONARY} from "../dictionary";
import _ from 'lodash';
import {BehaviorSubject} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class TableQueryTemplatesService {

	constructor(private ns:NotificationService, private rs:RouteService) {
	}

	isSomeValueChanged;
	templateActionInProcess;
	templates;
	selectedTemplate;
	dic = DICTIONARY;
	tableRefName;
	isEnabled = false;
	public templateUpdatedSuccessSubj = new BehaviorSubject<any>(null);

	// reset the service and get templates
	getTableQueryTemplates = (tableRefName) => {
		this.isEnabled = true;
		this.tableRefName = tableRefName;
		this.templateActionInProcess = false;
		this.templates = [];
		this.selectedTemplate = null;

		return new Promise(resolve => {
			this.rs.getTableTemplates('table_queries', tableRefName).then(response => {
				this.templates = response || [];
				resolve(this.templates);
			}, (err) => {
				resolve([]);
			});
		});
	}

	saveTableQueryTemplate = (template) => {
		const isExist = this.templates?.length && _.find(this.templates, {name: template.name});

		this.isSomeValueChanged = false;

		// update existing template
		if (isExist) {
			this.updateQueryTemplate(template);
		}
		// add new template
		else {
			this.templateActionInProcess = true;

			this.rs.createTableTemplate('table_queries', this.tableRefName, template).then(response => {
				this.ns.showInfoMessage(this.dic.MESSAGES.templateCreated);
				this.templates.push(template);
				this.templateUpdatedSuccessSubj.next(template);
				if (!this.isSomeValueChanged) {
					this.selectedTemplate = template;
				}

				this.templateActionInProcess = false;
			}, err => {
				this.templateActionInProcess = false;
			});
		}
	}

	deleteQueryTemplate = (template) => {
		if (this.templateActionInProcess) {
			return;
		}

		this.templateActionInProcess = true;

		this.rs.deleteTableTemplate('table_queries', this.tableRefName, {templateName: template.name}).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.templateDeleted);
			this.templateActionInProcess = false;

			_.remove(this.templates, {name: template.name});

			if (template.name === this.selectedTemplate.name) {
				this.isSomeValueChanged = true;
				this.selectedTemplate = null;
			}
		}, err => {
			this.templateActionInProcess = false;
		});
	}

	updateQueryTemplate = (templateData) => {
		const templateToChange = _.find(this.templates, {name: templateData.name});
		const data = {
			action: 'query',
			templateData
		};

		this.templateActionInProcess = true;

		this.rs.updateTableTemplate('table_queries', this.tableRefName, data).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.templateUpdated);

			templateToChange.query = templateData.query;
			this.templateUpdatedSuccessSubj.next(templateToChange);

			this.templateActionInProcess = false;
		}, err => {
			this.templateActionInProcess = false;
		});
	}

	toggleTemplateDefault = (template = this.selectedTemplate) => {
		const data = {
			action: 'default',
			templateData: template
		};

		this.templateActionInProcess = true;

		this.rs.updateTableTemplate('table_queries', this.tableRefName, data).then(response => {
			this.ns.showInfoMessage(this.dic.MESSAGES.templateUpdated);

			this.templates.forEach(templateObj => {
				if (templateObj.name !== template.name) {
					templateObj.default = false;
				}
			});
			template.default = !template.default;

			this.templateActionInProcess = false;
		}, err => {
			this.templateActionInProcess = false;
		});
	}

	clear = () => {
		this.selectedTemplate = null;

		const defaultTemplate = this.templates?.length && _.find(this.templates, 'default')
		if (defaultTemplate) {
			this.toggleTemplateDefault(defaultTemplate);
		}
	};
}
